import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'sm-tab',
  standalone: false,
  templateUrl: './sm-tab.component.html'
})
export class SmTabComponent {
  @Input() value?: string;
  @Input() header?: string;
  @Input() tabClass?: string;
  @Input() disabled = false;
  @Input() closable = false;
  @ViewChild('contentTpl', { static: true }) contentTpl!: TemplateRef<unknown>;
}
